import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { PageHeader } from 'br2s-ui-componentlibrary_r2_02';
import { LocalStorageService, PageNotFound } from 'br2s-ui-common-utils-02';
import {
  INSTRUCTION_PAGE_HEADERS,
  POST_LOGIN_INSTRUCTION_REROUTES,
  PRE_LOGIN_INSTRUCTION_ROUTES,
} from '@/utilities/constants/instructions';
import { instructionRoutesConfig } from './routes';
import './Instructions.scss';
import InstructionPage from './InstructionPage';

// temp filter for deprioritised transactions
// istanbul ignore next
const filteredDeprioRoutes = () =>
  Object.fromEntries(
    Object.entries(POST_LOGIN_INSTRUCTION_REROUTES).filter(([key]) => {
      switch (key) {
        case PRE_LOGIN_INSTRUCTION_ROUTES.NOTICE_OF_ERROR:
          return String(process.env.REACT_APP_SHOW_NOTICE_OF_ERROR) === 'true';
        case PRE_LOGIN_INSTRUCTION_ROUTES.VARIATION_SATISFACTION:
          return (
            String(process.env.REACT_APP_SHOW_VARIATION_SATISFACTION) === 'true'
          );
        case PRE_LOGIN_INSTRUCTION_ROUTES.POST_INITIATION_OF_WINDING_UP:
          return (
            String(process.env.REACT_APP_SHOW_MANAGE_WINDING_UP) === 'true'
          );
        case PRE_LOGIN_INSTRUCTION_ROUTES.FINANCIAL_YEAR_END:
          return (
            String(process.env.REACT_APP_SHOW_FINANCIAL_YEAR_END) === 'true'
          );
        default:
          return true;
      }
    }),
  );

const InstructionRoutes = () => {
  const location = useLocation();
  const [pathname] = location.pathname.split('/').reverse();
  const navigate = useNavigate();

  if (!(pathname in filteredDeprioRoutes())) {
    return <PageNotFound />;
  }

  if (LocalStorageService.hasAuth()) {
    return (
      <Navigate
        replace
        to={
          POST_LOGIN_INSTRUCTION_REROUTES[
            pathname as keyof typeof POST_LOGIN_INSTRUCTION_REROUTES
          ] ?? '/ '
        }
      />
    );
  }

  const pageTitle =
    INSTRUCTION_PAGE_HEADERS[pathname as keyof typeof INSTRUCTION_PAGE_HEADERS];
  const breadcrumbData = [
    { label: 'Home', onClick: () => navigate('/ ') },
    { label: pageTitle },
  ];

  return (
    <div className="cmn-instruction-page">
      {pathname in INSTRUCTION_PAGE_HEADERS && (
        <PageHeader
          id="instruction-header"
          title={pageTitle}
          breadcrumbData={breadcrumbData}
        />
      )}
      <Routes>
        {instructionRoutesConfig.map((config) => (
          <Route
            key={config.id}
            path={config.path}
            element={<InstructionPage {...config} />}
          />
        ))}
      </Routes>
    </div>
  );
};

export default InstructionRoutes;
